import { Injectable } from "@angular/core";
import { Headers, RequestOptions, Http } from '@angular/http';

@Injectable()
export class EmailService {

    constructor(private http: Http) { }

    sendTemplateEmail(emails: string, body: object) {
        let url = "https://fh2580wy1f.execute-api.us-west-2.amazonaws.com/prod/sendTemplateEmail";
        let headers = new Headers();
        headers.append('emails', emails);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, body, options);
    }
}


// WEBPACK FOOTER //
// ./src/app/email-service.ts